// // import React, { useEffect, useMemo, useRef, useState } from "react";

// // export default function PromoStrip({
// //   offers = [],
// //   intervalMs = 3500,
// //   storageKey = "promoStripDismissedUntil",
// //   size = "md",          // "md" | "lg"
// //   showBadge = false,    // hide "Ad" badge by default
// //   onApplyCode,          // callback(code)
// //   pauseOnHover = true,  // allow disabling hover-pause
// // }) {
// //   const [idx, setIdx] = useState(0);
// //   const [paused, setPaused] = useState(false);
// //   const [hidden, setHidden] = useState(false);
// //   const [appliedIdx, setAppliedIdx] = useState(null);
// //   const timerRef = useRef(null);

// //   const SIZES = {
// //     md: {
// //       containerPad: "py-2.5",
// //       bannerH: "h-24 md:h-28",
// //       adText: "text-[10px]",
// //       dismiss: "h-7 w-7",
// //       control: "h-9 w-9 md:h-10 md:w-10",
// //       dot: "h-1.5 w-1.5",
// //       dotOnExtra: "w-4",
// //       title: "text-base md:text-lg",
// //       subtitle: "text-sm md:text-base",
// //       cta: "text-sm md:text-base",
// //       codeText: "text-xs md:text-sm",
// //       codeBtn: "text-xs md:text-sm",
// //     },
// //     lg: {
// //       containerPad: "py-3",
// //       bannerH: "h-28 md:h-44",
// //       adText: "text-[11px]",
// //       dismiss: "h-8 w-8",
// //       control: "h-10 w-10 md:h-11 md:w-11",
// //       dot: "h-2 w-2",
// //       dotOnExtra: "w-5",
// //       title: "text-lg md:text-xl",
// //       subtitle: "text-sm md:text-lg",
// //       cta: "text-sm md:text-lg",
// //       codeText: "text-sm md:text-base",
// //       codeBtn: "text-sm md:text-base",
// //     },
// //   };

// //   const sz = SIZES[size] || SIZES.md;

// //   // read dismissal
// //   useEffect(() => {
// //     try {
// //       const until = Number(localStorage.getItem(storageKey) || 0);
// //       if (until && Date.now() < until) setHidden(true);
// //     } catch {}
// //   }, [storageKey]);

// //   const safeOffers = useMemo(
// //     () => (Array.isArray(offers) ? offers.filter(Boolean) : []),
// //     [offers]
// //   );

// //   // If only one offer, duplicate it so the slide animates
// //   const loopOffers = useMemo(() => {
// //     if (safeOffers.length === 1) return [safeOffers[0], safeOffers[0]];
// //     return safeOffers;
// //   }, [safeOffers]);

// //   // Reset idx when real offers change
// //   useEffect(() => {
// //     setIdx(0);
// //   }, [safeOffers.length]);

// //   // auto-rotate
// //   useEffect(() => {
// //     if (hidden || paused || loopOffers.length <= 1) return;
// //     timerRef.current = setInterval(() => {
// //       setIdx((i) => (i + 1) % loopOffers.length);
// //     }, intervalMs);
// //     return () => clearInterval(timerRef.current);
// //   }, [hidden, paused, loopOffers.length, intervalMs]);

// //   if (hidden || safeOffers.length === 0) return null;

// //   async function handleCopyAndApply(e, code, i) {
// //     e?.preventDefault?.();
// //     e?.stopPropagation?.();

// //     const trimmed = (code ?? "").trim();
// //     if (!trimmed) return;

// //     try {
// //       if (navigator?.clipboard?.writeText) {
// //         await navigator.clipboard.writeText(trimmed);
// //       }
// //     } catch {}

// //     if (typeof onApplyCode === "function") {
// //       await onApplyCode(trimmed);
// //     }
// //     setAppliedIdx(i);
// //     setTimeout(() => setAppliedIdx(null), 1500);
// //   }

// //   return (
// //     <section
// //       className="w-full bg-[#fff8e1] border-y"
// //       onMouseEnter={pauseOnHover ? () => setPaused(true) : undefined}
// //       onMouseLeave={pauseOnHover ? () => setPaused(false) : undefined}
// //       aria-label="Promotions"
// //     >
// //       <div className={`mx-auto max-w-7xl px-4 md:px-6 ${sz.containerPad}`}>
// //         <div className="relative rounded-xl bg-white border shadow-sm overflow-hidden">
// //           {showBadge && (
// //             <span className={`absolute left-2 top-2 z-10 font-semibold text-slate-600 bg-white/80 rounded px-1.5 py-0.5 border ${sz.adText}`}>
// //               Ad
// //             </span>
// //           )}

// //           <div className="relative">
// //             <div
// //               className="flex transition-transform duration-500 ease-out"
// //               style={{ transform: `translateX(-${idx * 100}%)` }}
// //             >
// //               {loopOffers.map((o, i) => (
// //                 <a
// //                   key={`${o.id ?? "offer"}-${i}`} // unique even for duplicates
// //                   href={o.href || "#"}
// //                   target={o.external === false ? "_self" : "_blank"}
// //                   rel="noreferrer"
// //                   className="block w-full shrink-0 focus:outline-none focus:ring-2 focus:ring-amber-400"
// //                   aria-label={o.alt || o.title || "Promotion"}
// //                 >
// //                   <div className={`relative w-full ${sz.bannerH}`}>
// //                     {o.img ? (
// //                       <img
// //                         src={o.img}
// //                         alt={o.alt || o.title || "Offer"}
// //                         className="h-full w-full object-cover"
// //                         loading="lazy"
// //                       />
// //                     ) : (
// //                       <div className="h-full w-full bg-gradient-to-r from-amber-100 to-yellow-50 flex items-center">
// //                         <div className="px-4 md:px-6 py-3 flex items-center gap-3 md:gap-4 w-full">
// //                           <div className="hidden md:block">
// //                             <PercentageIcon />
// //                           </div>
// //                           <div className="min-w-0">
// //                             <div className={`font-bold text-slate-900 truncate ${sz.title}`}>
// //                               {o.title || "Special Offer"}
// //                             </div>
// //                             {o.subtitle && (
// //                               <div className={`text-slate-700 truncate ${sz.subtitle}`}>
// //                                 {o.subtitle}
// //                               </div>
// //                             )}
// //                           </div>
// //                           {o.cta && (
// //                             <span className={`ml-auto font-semibold text-amber-700 underline ${sz.cta}`}>
// //                               {o.cta}
// //                             </span>
// //                           )}
// //                         </div>
// //                       </div>
// //                     )}

// //                     {(o.couponCode || o.title || o.subtitle) && (
// //                       <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent">
// //                         <div className="pointer-events-auto px-4 md:px-6 py-2 md:py-3 flex items-center gap-3">
// //                           <div className="min-w-0">
// //                             {o.title && (
// //                               <div className={`text-white font-semibold truncate ${sz.title}`}>
// //                                 {o.title}
// //                               </div>
// //                             )}
// //                             {o.subtitle && (
// //                               <div className={`text-white/90 truncate ${sz.subtitle}`}>
// //                                 {o.subtitle}
// //                               </div>
// //                             )}
// //                           </div>

// //                           {o.couponCode && (
// //                             <div className="ml-auto flex items-center gap-2">
// //                               <span className={`font-mono bg-white text-slate-900 rounded px-2 py-1 border ${sz.codeText}`}>
// //                                 {o.couponCode}
// //                               </span>
// //                               <button
// //                                 onClick={(e) => handleCopyAndApply(e, o.couponCode, i)}
// //                                 className={`rounded-full bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold px-3 py-1 border shadow ${sz.codeBtn}`}
// //                               >
// //                                 {appliedIdx === i ? "Applied ✓" : "Copy & Apply"}
// //                               </button>
// //                             </div>
// //                           )}
// //                         </div>
// //                       </div>
// //                     )}
// //                   </div>
// //                 </a>
// //               ))}
// //             </div>

// //             {/* Dots reflect real offers count */}
// //             {safeOffers.length > 1 && (
// //               <div className="absolute bottom-1.5 left-0 right-0 flex items-center justify-center gap-1.5">
// //                 {safeOffers.map((_, i) => (
// //                   <button
// //                     key={i}
// //                     onClick={() => setIdx(i)}
// //                     className={`rounded-full transition-all ${sz.dot} ${i === idx ? `${sz.dotOnExtra} bg-slate-900` : "bg-slate-300"}`}
// //                     aria-label={`Go to promotion ${i + 1}`}
// //                   />
// //                 ))}
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// // function PercentageIcon() {
// //   return (
// //     <svg width="24" height="24" viewBox="0 0 24 24" className="text-amber-600" fill="currentColor">
// //       <circle cx="7" cy="7" r="2" />
// //       <circle cx="17" cy="17" r="2" />
// //       <path d="M19 5L5 19" stroke="currentColor" strokeWidth="2" fill="none" />
// //     </svg>
// //   );
// // }


// import React, { useEffect, useMemo, useRef, useState } from "react";

// /**
//  * PromoStrip
//  * ------------------------------------------------------------------
//  * props:
//  * - offers: [{ id, img, title, subtitle, cta, href, external, couponCode, alt }]
//  * - intervalMs: autoplay interval
//  * - storageKey: localStorage key to remember dismiss-until timestamp
//  * - dismissForMs: how long to keep it hidden after dismiss
//  * - size: "md" | "lg"
//  * - showBadge: boolean ("Ad")
//  * - pauseOnHover: boolean
//  * - onApplyCode: (code) => Promise<void> | void
//  */
// export default function PromoStrip({
//   offers = [],
//   intervalMs = 3500,
//   storageKey = "promoStripDismissedUntil",
//   dismissForMs = 7 * 24 * 60 * 60 * 1000, // 7 days
//   size = "md",
//   showBadge = false,
//   onApplyCode,
//   pauseOnHover = true,
// }) {
//   const [idx, setIdx] = useState(0);
//   const [paused, setPaused] = useState(false);
//   const [hidden, setHidden] = useState(false);
//   const [appliedIdx, setAppliedIdx] = useState(null);
//   const [drag, setDrag] = useState({ active: false, startX: 0, delta: 0 });
//   const timerRef = useRef(null);
//   const progressRef = useRef(null);
//   const lastTickRef = useRef(Date.now());
//   const progressPctRef = useRef(0);

//   const SIZES = {
//     md: {
//       containerPad: "py-2.5",
//       bannerH: "h-28 md:h-32",
//       adText: "text-[10px]",
//       dismiss: "h-8 w-8",
//       control: "h-9 w-9 md:h-10 md:w-10",
//       dot: "h-1.5 w-1.5",
//       dotOnExtra: "w-4",
//       title: "text-base md:text-lg",
//       subtitle: "text-[13px] md:text-sm",
//       cta: "text-xs md:text-sm",
//       codeText: "text-xs md:text-sm",
//       codeBtn: "text-xs md:text-sm",
//     },
//     lg: {
//       containerPad: "py-3",
//       bannerH: "h-36 md:h-48",
//       adText: "text-[11px]",
//       dismiss: "h-9 w-9",
//       control: "h-10 w-10 md:h-11 md:w-11",
//       dot: "h-2 w-2",
//       dotOnExtra: "w-5",
//       title: "text-lg md:text-xl",
//       subtitle: "text-sm md:text-base",
//       cta: "text-sm md:text-base",
//       codeText: "text-sm md:text-base",
//       codeBtn: "text-sm md:text-base",
//     },
//   };
//   const sz = SIZES[size] || SIZES.md;

//   // read dismissal
//   useEffect(() => {
//     try {
//       const until = Number(localStorage.getItem(storageKey) || 0);
//       if (until && Date.now() < until) setHidden(true);
//     } catch {}
//   }, [storageKey]);

//   const safeOffers = useMemo(
//     () => (Array.isArray(offers) ? offers.filter(Boolean) : []),
//     [offers]
//   );

//   // When there’s exactly one, still show but no autoplay/controls
//   const loopOffers = safeOffers;

//   // Reset on data change
//   useEffect(() => {
//     setIdx(0);
//   }, [safeOffers.length]);

//   // Progress + autoplay (requestAnimationFrame for smooth progress bar)
//   useEffect(() => {
//     if (hidden || paused || loopOffers.length <= 1) return;

//     progressPctRef.current = 0;
//     lastTickRef.current = Date.now();

//     const tick = () => {
//       if (paused) return;
//       const now = Date.now();
//       const dt = now - lastTickRef.current;
//       lastTickRef.current = now;

//       progressPctRef.current += dt / intervalMs;
//       if (progressRef.current) {
//         progressRef.current.style.setProperty(
//           "--pct",
//           Math.min(progressPctRef.current, 1).toString()
//         );
//       }

//       if (progressPctRef.current >= 1) {
//         progressPctRef.current = 0;
//         setIdx((i) => (i + 1) % loopOffers.length);
//       }
//       timerRef.current = requestAnimationFrame(tick);
//     };

//     timerRef.current = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(timerRef.current);
//   }, [hidden, paused, loopOffers.length, intervalMs]);

//   if (hidden || safeOffers.length === 0) return null;

//   async function handleCopyAndApply(e, code, i) {
//     e?.preventDefault?.();
//     e?.stopPropagation?.();

//     const trimmed = (code ?? "").trim();
//     if (!trimmed) return;

//     try {
//       if (navigator?.clipboard?.writeText) {
//         await navigator.clipboard.writeText(trimmed);
//       }
//     } catch {}

//     if (typeof onApplyCode === "function") {
//       await onApplyCode(trimmed);
//     }
//     setAppliedIdx(i);
//     setTimeout(() => setAppliedIdx(null), 1400);
//   }

//   function onDismiss() {
//     setHidden(true);
//     try {
//       localStorage.setItem(storageKey, String(Date.now() + dismissForMs));
//     } catch {}
//   }

//   // Controls
//   const goPrev = () => {
//     progressPctRef.current = 0;
//     setIdx((i) => (i - 1 + loopOffers.length) % loopOffers.length);
//   };
//   const goNext = () => {
//     progressPctRef.current = 0;
//     setIdx((i) => (i + 1) % loopOffers.length);
//   };

//   // Drag / swipe
//   const startDrag = (clientX) =>
//     setDrag({ active: true, startX: clientX, delta: 0 });
//   const moveDrag = (clientX) =>
//     setDrag((d) => (d.active ? { ...d, delta: clientX - d.startX } : d));
//   const endDrag = () => {
//     if (!drag.active) return;
//     const threshold = 60; // px
//     if (drag.delta > threshold) goPrev();
//     else if (drag.delta < -threshold) goNext();
//     setDrag({ active: false, startX: 0, delta: 0 });
//   };

//   // Derived transform (drag)
//   const slideTransform = `translateX(calc(-${idx * 100}% + ${drag.delta}px))`;

//   return (
//     <section
//       className="w-full bg-gradient-to-b from-[#fff8e1] to-[#fff1bf] border-y"
//       onMouseEnter={pauseOnHover ? () => setPaused(true) : undefined}
//       onMouseLeave={pauseOnHover ? () => setPaused(false) : undefined}
//       aria-label="Promotions"
//     >
//       <div className={`mx-auto max-w-7xl px-4 md:px-6 ${sz.containerPad}`}>
//         <div className="relative overflow-hidden rounded-2xl border border-amber-100/60 bg-white/80 backdrop-blur shadow-[0_8px_20px_rgba(0,0,0,0.06)]">
//           {/* Accent top bar */}
//           <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400" />

//           {/* Ad badge */}
//           {showBadge && (
//             <span
//               className={`absolute left-3 top-3 z-20 font-semibold text-slate-700 bg-white/90 rounded px-1.5 py-0.5 border ${sz.adText}`}
//             >
//               Ad
//             </span>
//           )}

//           {/* Dismiss */}
//           <button
//             onClick={onDismiss}
//             aria-label="Dismiss promotions"
//             className={`absolute right-2 top-2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.dismiss}`}
//           >
//             <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
//               <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" />
//             </svg>
//           </button>

//           {/* Controls */}
//           {loopOffers.length > 1 && (
//             <>
//               <button
//                 onClick={goPrev}
//                 aria-label="Previous promotion"
//                 className={`absolute left-2 top-1/2 -translate-y-1/2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.control}`}
//               >
//                 <ChevronLeft />
//               </button>
//               <button
//                 onClick={goNext}
//                 aria-label="Next promotion"
//                 className={`absolute right-2 top-1/2 -translate-y-1/2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.control}`}
//               >
//                 <ChevronRight />
//               </button>
//             </>
//           )}

//           {/* Slides */}
//           <div
//             className="relative select-none touch-pan-y"
//             onMouseDown={(e) => startDrag(e.clientX)}
//             onMouseMove={(e) => drag.active && moveDrag(e.clientX)}
//             onMouseUp={endDrag}
//             onMouseLeave={drag.active ? endDrag : undefined}
//             onTouchStart={(e) => startDrag(e.touches[0].clientX)}
//             onTouchMove={(e) => moveDrag(e.touches[0].clientX)}
//             onTouchEnd={endDrag}
//           >
//             <div
//               className="flex transition-transform duration-500 ease-out will-change-transform"
//               style={{ transform: drag.active ? slideTransform : `translateX(-${idx * 100}%)` }}
//             >
//               {loopOffers.map((o, i) => (
//                 <a
//                   key={`${o.id ?? "offer"}-${i}`}
//                   href={o.href || "#"}
//                   target={o.external === false ? "_self" : "_blank"}
//                   rel="noreferrer"
//                   className="block w-full shrink-0 focus:outline-none focus:ring-2 focus:ring-amber-400"
//                   aria-label={o.alt || o.title || "Promotion"}
//                 >
//                   <div className={`relative w-full ${sz.bannerH}`}>
//                     {/* Image or gradient fallback */}
//                     {o.img ? (
//                       <img
//                         src={o.img}
//                         alt={o.alt || o.title || "Offer"}
//                         className="h-full w-full object-cover"
//                         loading="lazy"
//                       />
//                     ) : (
//                       <div className="h-full w-full bg-gradient-to-r from-amber-100 via-yellow-50 to-white flex items-center">
//                         <div className="px-4 md:px-6 py-3 flex items-center gap-3 md:gap-4 w-full">
//                           <div className="hidden md:block">
//                             <PercentageIcon />
//                           </div>
//                           <div className="min-w-0">
//                             <div className={`font-bold text-slate-900 truncate ${sz.title}`}>
//                               {o.title || "Special Offer"}
//                             </div>
//                             {o.subtitle && (
//                               <div className={`text-slate-700 truncate ${sz.subtitle}`}>
//                                 {o.subtitle}
//                               </div>
//                             )}
//                           </div>
//                           {o.cta && (
//                             <span className={`ml-auto font-semibold text-amber-700 underline ${sz.cta}`}>
//                               {o.cta}
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     )}

//                     {/* Overlay content (title / subtitle / coupon) */}
//                     {(o.couponCode || o.title || o.subtitle) && (
//                       <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/35 to-transparent">
//                         <div className="pointer-events-auto px-4 md:px-6 py-2 md:py-3 flex items-center gap-3">
//                           <div className="min-w-0 text-white">
//                             {o.title && (
//                               <div className={`font-semibold truncate ${sz.title}`}>{o.title}</div>
//                             )}
//                             {o.subtitle && (
//                               <div className={`text-white/90 truncate ${sz.subtitle}`}>
//                                 {o.subtitle}
//                               </div>
//                             )}
//                           </div>

//                           {o.couponCode && (
//                             <div className="ml-auto flex items-center gap-2">
//                               <span className={`font-mono bg-white text-slate-900 rounded px-2 py-1 border ${sz.codeText}`}>
//                                 {o.couponCode}
//                               </span>
//                               <button
//                                 onClick={(e) => handleCopyAndApply(e, o.couponCode, i)}
//                                 className={`rounded-full bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold px-3 py-1 border shadow ${sz.codeBtn}`}
//                               >
//                                 {appliedIdx === i ? "Applied ✓" : "Copy & Apply"}
//                               </button>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 </a>
//               ))}
//             </div>

//             {/* Progress bar (only when >1) */}
//             {loopOffers.length > 1 && (
//               <div
//                 ref={progressRef}
//                 className="absolute left-0 right-0 bottom-0 h-0.5 bg-white/50"
//                 style={{
//                   backgroundImage:
//                     "linear-gradient(to right, rgba(255,255,255,0.5) var(--pct, 0), transparent 0)",
//                   backgroundRepeat: "no-repeat",
//                   backgroundSize: "calc(var(--pct, 0) * 100%) 100%",
//                 }}
//               />
//             )}

//             {/* Dots (count = real offers) */}
//             {safeOffers.length > 1 && (
//               <div className="absolute bottom-1.5 left-0 right-0 flex items-center justify-center gap-1.5">
//                 {safeOffers.map((_, i) => (
//                   <button
//                     key={i}
//                     onClick={() => {
//                       progressPctRef.current = 0;
//                       setIdx(i);
//                     }}
//                     className={`rounded-full transition-all ${sz.dot} ${
//                       i === idx ? `${sz.dotOnExtra} bg-slate-900` : "bg-slate-300"
//                     }`}
//                     aria-label={`Go to promotion ${i + 1}`}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// /* ---------------- Icons ---------------- */
// function PercentageIcon() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" className="text-amber-600" fill="currentColor">
//       <circle cx="7" cy="7" r="2" />
//       <circle cx="17" cy="17" r="2" />
//       <path d="M19 5L5 19" stroke="currentColor" strokeWidth="2" fill="none" />
//     </svg>
//   );
// }
// function ChevronLeft() {
//   return (
//     <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
//       <polyline points="15 18 9 12 15 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );
// }
// function ChevronRight() {
//   return (
//     <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
//       <polyline points="9 18 15 12 9 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//     </svg>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from "react";

/**
 * PromoStrip
 * props:
 * - offers: [{ id, img, title, subtitle, cta, href, external, couponCode, alt, isShow }]
 * - intervalMs, storageKey, dismissForMs, size, showBadge, pauseOnHover, onApplyCode
 */
export default function PromoStrip({
  offers = [],
  intervalMs = 3500,
  storageKey = "promoStripDismissedUntil",
  dismissForMs = 7 * 24 * 60 * 60 * 1000, // 7 days
  size = "md",
  showBadge = false,
  onApplyCode,
  pauseOnHover = true,
}) {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [appliedIdx, setAppliedIdx] = useState(null);
  const [drag, setDrag] = useState({ active: false, startX: 0, delta: 0 });

  const timerRef = useRef(null);
  const progressRef = useRef(null);
  const lastTickRef = useRef(Date.now());
  const progressPctRef = useRef(0);

  const SIZES = {
    md: {
      containerPad: "py-2.5",
      bannerH: "h-28 md:h-32",
      adText: "text-[10px]",
      dismiss: "h-8 w-8",
      control: "h-9 w-9 md:h-10 md:w-10",
      dot: "h-1.5 w-1.5",
      dotOnExtra: "w-4",
      title: "text-base md:text-lg",
      subtitle: "text-[13px] md:text-sm",
      cta: "text-xs md:text-sm",
      codeText: "text-xs md:text-sm",
      codeBtn: "text-xs md:text-sm",
    },
    lg: {
      containerPad: "py-3",
      bannerH: "h-64",
      adText: "text-[11px]",
      dismiss: "h-9 w-9",
      control: "h-10 w-10 md:h-11 md:w-11",
      dot: "h-2 w-2",
      dotOnExtra: "w-5",
      title: "text-lg md:text-xl",
      subtitle: "text-sm md:text-base",
      cta: "text-sm md:text-base",
      codeText: "text-sm md:text-base",
      codeBtn: "text-sm md:text-base",
    },
  };
  const sz = SIZES[size] || SIZES.md;

  // read dismissal
  useEffect(() => {
    try {
      const until = Number(localStorage.getItem(storageKey) || 0);
      if (until && Date.now() < until) setHidden(true);
    } catch {}
  }, [storageKey]);

  // ✅ filter out offers where isShow === false
  const safeOffers = useMemo(
    () =>
      Array.isArray(offers)
        ? offers.filter((o) => o && o.isShow !== false)
        : [],
    [offers]
  );

  // when hidden or empty -> render nothing
  const shouldRender = !hidden && safeOffers.length > 0;
  const loopOffers = safeOffers;

  // reset index when data size changes
  useEffect(() => {
    if (shouldRender) setIdx(0);
  }, [safeOffers.length, shouldRender]);

  // progress/autoplay via rAF
  useEffect(() => {
    if (!shouldRender || paused || loopOffers.length <= 1) return;

    progressPctRef.current = 0;
    lastTickRef.current = Date.now();

    const tick = () => {
      if (paused) return;
      const now = Date.now();
      const dt = now - lastTickRef.current;
      lastTickRef.current = now;

      progressPctRef.current += dt / intervalMs;
      if (progressRef.current) {
        progressRef.current.style.setProperty(
          "--pct",
          Math.min(progressPctRef.current, 1).toString()
        );
      }
      if (progressPctRef.current >= 1) {
        progressPctRef.current = 0;
        setIdx((i) => (i + 1) % loopOffers.length);
      }
      timerRef.current = requestAnimationFrame(tick);
    };

    timerRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(timerRef.current);
  }, [paused, loopOffers.length, intervalMs, shouldRender]);

  if (!shouldRender) return null;

  async function handleCopyAndApply(e, code, i) {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    const trimmed = (code ?? "").trim();
    if (!trimmed) return;
    try {
      if (navigator?.clipboard?.writeText) await navigator.clipboard.writeText(trimmed);
    } catch {}
    if (typeof onApplyCode === "function") await onApplyCode(trimmed);
    setAppliedIdx(i);
    setTimeout(() => setAppliedIdx(null), 1400);
  }

  function onDismiss() {
    setHidden(true);
    try {
      localStorage.setItem(storageKey, String(Date.now() + dismissForMs));
    } catch {}
  }

  const goPrev = () => {
    progressPctRef.current = 0;
    setIdx((i) => (i - 1 + loopOffers.length) % loopOffers.length);
  };
  const goNext = () => {
    progressPctRef.current = 0;
    setIdx((i) => (i + 1) % loopOffers.length);
  };

  const startDrag = (clientX) => setDrag({ active: true, startX: clientX, delta: 0 });
  const moveDrag = (clientX) => setDrag((d) => (d.active ? { ...d, delta: clientX - d.startX } : d));
  const endDrag = () => {
    if (!drag.active) return;
    const threshold = 60;
    if (drag.delta > threshold) goPrev();
    else if (drag.delta < -threshold) goNext();
    setDrag({ active: false, startX: 0, delta: 0 });
  };

  const slideTransform = `translateX(calc(-${idx * 100}% + ${drag.delta}px))`;

  return (
    <section
      className="w-full bg-gradient-to-b from-[#fff8e1] to-[#fff1bf] border-y"
      onMouseEnter={pauseOnHover ? () => setPaused(true) : undefined}
      onMouseLeave={pauseOnHover ? () => setPaused(false) : undefined}
      aria-label="Promotions"
    >
      <div className={`mx-auto max-w-7xl px-4 md:px-6 ${sz.containerPad}`}>
        <div className="relative overflow-hidden rounded-2xl border border-amber-100/60 bg-white/80 backdrop-blur shadow-[0_8px_20px_rgba(0,0,0,0.06)]">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-amber-400 via-amber-500 to-amber-400" />

          {showBadge && (
            <span className={`absolute left-3 top-3 z-20 font-semibold text-slate-700 bg-white/90 rounded px-1.5 py-0.5 border ${sz.adText}`}>
              Ad
            </span>
          )}

          <button
            onClick={onDismiss}
            aria-label="Dismiss promotions"
            className={`absolute right-2 top-2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.dismiss}`}
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
              <path d="M6 18L18 6M6 6l12 12" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>

          {loopOffers.length > 1 && (
            <>
              <button
                onClick={goPrev}
                aria-label="Previous promotion"
                className={`absolute left-2 top-1/2 -translate-y-1/2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.control}`}
              >
                <ChevronLeft />
              </button>
              <button
                onClick={goNext}
                aria-label="Next promotion"
                className={`absolute right-2 top-1/2 -translate-y-1/2 z-20 grid place-items-center rounded-full border border-amber-100/80 bg-white/90 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${sz.control}`}
              >
                <ChevronRight />
              </button>
            </>
          )}

          <div
            className="relative select-none touch-pan-y"
            onMouseDown={(e) => startDrag(e.clientX)}
            onMouseMove={(e) => drag.active && moveDrag(e.clientX)}
            onMouseUp={endDrag}
            onMouseLeave={drag.active ? endDrag : undefined}
            onTouchStart={(e) => startDrag(e.touches[0].clientX)}
            onTouchMove={(e) => moveDrag(e.touches[0].clientX)}
            onTouchEnd={endDrag}
          >
            <div
              className="flex transition-transform duration-500 ease-out will-change-transform"
              style={{ transform: drag.active ? slideTransform : `translateX(-${idx * 100}%)` }}
            >
              {loopOffers.map((o, i) => (
                <a
                  key={`${o.id ?? "offer"}-${i}`}
                  href={o.href || "#"}
                  target={o.external === false ? "_self" : "_blank"}
                  rel="noreferrer"
                  className="block w-full shrink-0 focus:outline-none focus:ring-2 focus:ring-amber-400"
                  aria-label={o.alt || o.title || "Promotion"}
                >
                  <div className={`relative w-full ${sz.bannerH}`}>
                    {o.img ? (
                      <img
                        src={o.img}
                        alt={o.alt || o.title || "Offer"}
                        className="h-auto w-full object-cover object-center "
                        loading="lazy"
                      />
                    ) : (
                      <div className="h-full w-full bg-gradient-to-r from-amber-100 via-yellow-50 to-white flex items-center">
                        <div className="px-4 md:px-6 py-3 flex items-center gap-3 md:gap-4 w-full">
                          <div className="hidden md:block">
                            <PercentageIcon />
                          </div>
                          <div className="min-w-0">
                            <div className={`font-bold text-slate-900 truncate ${sz.title}`}>
                              {o.title || "Special Offer"}
                            </div>
                            {o.subtitle && (
                              <div className={`text-slate-700 truncate ${sz.subtitle}`}>
                                {o.subtitle}
                              </div>
                            )}
                          </div>
                          {o.cta && (
                            <span className={`ml-auto font-semibold text-amber-700 underline ${sz.cta}`}>
                              {o.cta}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {(o.couponCode || o.title || o.subtitle) && (
                      <div className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 via-black/35 to-transparent">
                        <div className="pointer-events-auto px-4 md:px-6 py-2 md:py-3 flex items-center gap-3">
                          <div className="min-w-0 text-white">
                            {o.title && (
                              <div className={`font-semibold truncate ${sz.title}`}>{o.title}</div>
                            )}
                            {o.subtitle && (
                              <div className={`text-white/90 truncate ${sz.subtitle}`}>
                                {o.subtitle}
                              </div>
                            )}
                          </div>

                          {o.couponCode && (
                            <div className="ml-auto flex items-center gap-2">
                              <span className={`font-mono bg-white text-slate-900 rounded px-2 py-1 border ${sz.codeText}`}>
                                {o.couponCode}
                              </span>
                              <button
                                onClick={(e) => handleCopyAndApply(e, o.couponCode, i)}
                                className={`rounded-full bg-amber-400 hover:bg-amber-300 text-slate-900 font-semibold px-3 py-1 border shadow ${sz.codeBtn}`}
                              >
                                {appliedIdx === i ? "Applied ✓" : "Copy & Apply"}
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </a>
              ))}
            </div>

            {loopOffers.length > 1 && (
              <div
                ref={progressRef}
                className="absolute left-0 right-0 bottom-0 h-0.5 bg-white/50"
                style={{
                  backgroundImage:
                    "linear-gradient(to right, rgba(255,255,255,0.5) var(--pct, 0), transparent 0)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "calc(var(--pct, 0) * 100%) 100%",
                }}
              />
            )}

            {safeOffers.length > 1 && (
              <div className="absolute bottom-1.5 left-0 right-0 flex items-center justify-center gap-1.5">
                {safeOffers.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      progressPctRef.current = 0;
                      setIdx(i);
                    }}
                    className={`rounded-full transition-all ${sz.dot} ${
                      i === idx ? `${sz.dotOnExtra} bg-slate-900` : "bg-slate-300"
                    }`}
                    aria-label={`Go to promotion ${i + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

/* ---------------- Icons ---------------- */
function PercentageIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" className="text-amber-600" fill="currentColor">
      <circle cx="7" cy="7" r="2" />
      <circle cx="17" cy="17" r="2" />
      <path d="M19 5L5 19" stroke="currentColor" strokeWidth="2" fill="none" />
    </svg>
  );
}
function ChevronLeft() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
      <polyline points="15 18 9 12 15 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function ChevronRight() {
  return (
    <svg viewBox="0 0 24 24" className="h-4 w-4" stroke="currentColor" fill="none">
      <polyline points="9 18 15 12 9 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

